import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { GlobalErrorBoundary } from '@bingads-webui-react/global-error-boundary';
import { withGlobalErrorOptions } from './global-error-options';

export const withGlobalErrorView = (WrappedComponent, errorOptions = null, componentName, errorAction) => {
  const GlobalErrorView = ({ globalErrorOptions = errorOptions, ...props }) => (
    <GlobalErrorBoundary
      {...globalErrorOptions}
    >
      <WrappedComponent
        {...props}
      />
    </GlobalErrorBoundary >
  );

  GlobalErrorView.propTypes = {
    globalErrorOptions: PropTypes.shape({
      logError: PropTypes.func.isRequired,
    }).isRequired,
  };

  return errorOptions ? GlobalErrorView : withGlobalErrorOptions(GlobalErrorView, componentName, errorAction);
};

export const withComponentErrorLogging = _.partial(withGlobalErrorView, _, null, _);
